<script setup lang="ts">
import { ArrowTopRightOnSquareIcon } from '@heroicons/vue/24/outline';

defineProps<{ provider: 'frankieOne' | 'sumsub'; href?: string }>();

const styles: Record<'frankieOne' | 'sumsub', string> = {
  frankieOne: 'bg-blue-50 text-blue-700',
  sumsub: 'bg-indigo-50 text-indigo-700',
};

const hoverStyles: Record<'frankieOne' | 'sumsub', string> = {
  frankieOne: 'hover:bg-blue-100',
  sumsub: 'hover:bg-indigo-100',
};

const labels: Record<'frankieOne' | 'sumsub', string> = {
  frankieOne: 'FrankieOne',
  sumsub: 'Sumsub',
};
</script>

<template>
  <a
    v-if="href"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Open in provider"
    title="Open in provider"
    class="inline-flex w-fit items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold"
    :class="[styles[provider], hoverStyles[provider]]"
  >
    {{ labels[provider] }}
    <ArrowTopRightOnSquareIcon class="size-3" />
  </a>
  <span
    v-else
    class="inline-flex w-fit items-center rounded-full px-2 py-0.5 text-xs font-semibold"
    :class="styles[provider]"
  >
    {{ labels[provider] }}
  </span>
</template>
